"use client";

import { SkeletonLoading} from '@pixelated-tech/components';

export default function Loading() {
	return <SkeletonLoading />;
}

